import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.keys";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapState } from 'vuex';
import { clone, get } from 'lodash';
export default {
  name: 'CoreDtwinStateEditValue',
  props: {
    // the current edited binding
    lclModel: {
      type: Object,
      required: true
    },
    // is this an edit or new creation?
    mode: {
      type: String,
      required: false,
      default: function _default() {
        return 'edit';
      }
    },
    templateContext: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data: function data() {
    var _this = this;

    return {
      valueWasChanged: false,
      stateIsNull: get(this.lclModel, 'value.value') === null,
      skipValueSaving: false,
      skipTransformer: true,
      requiredRule: [function (v) {
        return !!v || _this.$i18n_t('Common.fieldRequired');
      }],
      jsonErrorMsg: ''
    };
  },
  computed: _objectSpread(_objectSpread({}, mapState('app', ['inpOutlined', 'inpFilled', 'image', 'color', 'UiTheme', 'permissions'])), {}, {
    isSuperSystemAdmin: function isSuperSystemAdmin() {
      return this.permissions['super.system.manage'];
    },
    stateValue: function stateValue() {
      if (this.lclModel.properties.valueType === 'json') {
        try {
          return JSON.stringify(get(this.lclModel, 'value.value'), null, 1);
        } catch (error) {
          console.error(error);
        }
      }

      return "".concat(get(this.lclModel, 'value.value'));
    },
    typeItems: function typeItems() {
      return ['number', 'boolean', 'string', 'json'];
    },
    jsonRule: function jsonRule() {
      var _this2 = this;

      return [function (v) {
        return !!v || _this2.$i18n_t('Common.fieldRequired');
      }, function (v) {
        try {
          JSON.parse(v);
        } catch (error) {
          return _this2.$i18n_t('DigitalTwin.DigitalTwin.states.invalidJSON');
        }

        return true;
      }];
    }
  }),
  watch: {
    stateIsNull: function stateIsNull(val, oldVal) {
      if (val === true && oldVal !== true) {
        this.lclModel.value.value = null;
      }
    },
    stateValue: function stateValue() {
      this.stateIsNull = get(this.lclModel, 'value.value') === null;
    },
    'lclModel.properties.valueType': function lclModelPropertiesValueType(newVal) {
      if (newVal === 'boolean') {
        this.lclModel.value.value = false;
      }
    },
    lclModel: function lclModel() {
      this.cleanupBooleanValue();
    }
  },
  mounted: function mounted() {
    if (!this.lclModel.value) {
      this.lclModel.value = {};
    }

    this.cleanupBooleanValue();
  },
  methods: {
    clickedBoolRadio: function clickedBoolRadio() {
      this.valueWasChanged = true;
      this.lclModel.value = clone(this.lclModel.value);
    },
    cleanupBooleanValue: function cleanupBooleanValue() {
      if (this.lclModel.properties.valueType === 'boolean') {
        if (get(this.lclModel, 'value.value') !== true && get(this.lclModel, 'value.value') !== false && get(this.lclModel, 'value.value') !== null) {
          this.lclModel.value.value = false;
          this.valueWasChanged = true;
          this.$emit('input');
        }
      }
    },
    valueFieldEdited: function valueFieldEdited(e) {
      if (this.lclModel.properties.valueType === 'json') {
        try {
          this.jsonErrorMsg = '';
          this.lclModel.value.value = JSON.parse(e);
        } catch (_) {
          this.jsonErrorMsg = this.$i18n_t('DigitalTwin.DigitalTwin.states.invalidJSON');
        }
      } else if (this.lclModel.properties.valueType === 'boolean') {
        // the used vuetify-version seems to have a bug with radio-groups and null values
        // which uses the index instead of null, so have to hardcode this here
        // https://github.com/vuetifyjs/vuetify/issues/8876
        if (get(this.lclModel, 'value.value') === 2) {
          this.lclModel.value.value = null;
        }
      }

      this.valueWasChanged = true;
      this.lclModel.value.time = new Date().toISOString();
      this.$emit('input');
    },
    saveState: function saveState() {
      if (this.lclModel.properties.valueType === 'number') {
        this.lclModel.value.value = parseFloat(get(this.lclModel, 'value.value'));
      }

      if (this.skipValueSaving) {
        this.lclModel.value.hasChanged = false;
        this.lclModel.value.skipTransformer = true; // for create-actions, no initial value

        this.lclModel.noUpdate = true;
      } else {
        this.lclModel.value.hasChanged = this.valueWasChanged;
        this.lclModel.value.skipTransformer = this.skipTransformer;
      }
    }
  }
};